import { Box, Flex, Text } from "@mantine/core";

import type { ReceiptStatus } from "@/sdk/agent/chat";

import { AnimatedDoubleCheckMark } from "./AnimatedDoubleCheckMark";
import classes from "./message-component-styles.module.css";

const ReceiptStatusIcon = ({ showReceipt, receiptStatus }: { showReceipt: boolean; receiptStatus: ReceiptStatus }) => {
    if (!showReceipt || receiptStatus === "unknown") return null;
    // We only account for two receipt statuses. If we need more functionality make this component more complicated at that time.
    const isRead = receiptStatus === "read";
    const label = isRead ? "Message seen" : "Message delivered";

    return <AnimatedDoubleCheckMark double={isRead} aria-description={label} tooltipText={label} />;
};

interface MessageContentProps {
    content: string | null;
    showReceipt: boolean;
    receiptStatus: ReceiptStatus;
}

/**
 * Renders message content with a receipt status icon at the bottom right
 * Uses CSS classes with data attributes to control layout and receipt positioning
 * TODO: tweak receipt float capabilities to allow the text to flow around the icon in a more natural way
 */
export const MessageContent = ({ content, showReceipt, receiptStatus }: MessageContentProps) => {
    const hasReceipt = showReceipt && receiptStatus !== "unknown";

    return (
        <Box className={classes.contentWrapper}>
            <Flex className={classes.messageContent} data-has-receipt={hasReceipt}>
                <Text component="span" className={classes.textContent} inherit>
                    {content}
                </Text>
                {hasReceipt && (
                    <Box className={classes.receiptIcon}>
                        <ReceiptStatusIcon showReceipt={showReceipt} receiptStatus={receiptStatus} />
                    </Box>
                )}
            </Flex>
        </Box>
    );
};
